<template>
  <div class="form--group">
    <div class="left--col">
      <label>
        <span>{{ $t('addListing.facility') }}</span>
        <ListingScoreField field-code="FACILITY_EXISTS" />
      </label>
    </div>
    <div class="right--col">
      <facility-with-unit-field
        v-for="facility in facilitiesWithUnit"
        :key="facility.id"
        :name="facility.name"
        :selected="facility.selected"
        :id="facility.id"
        :unitName="facility.uom_name"
        :amount="facility.amount"
        ref="facilityWithUnitRef"
      />
      <div class="form--group row">
        <facility-without-unit-field
          v-for="facility in facilitiesWithoutUnit"
          :key="facility.id"
          :name="facility.name"
          :selected="facility.selected"
          :id="facility.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListingScoreField from '@/components/listing-form/listing-score-field.vue';
const FacilityWithUnitField = () =>
  import('@/components/listing-form/sect2/facility/facility-with-unit-field.vue');
const FacilityWithoutUnitField = () =>
  import('@/components/listing-form/sect2/facility/facility-without-unit-field.vue');

export default {
  name: 'facilities-section',
  components: {
    FacilityWithUnitField,
    FacilityWithoutUnitField,
    ListingScoreField,
    // FacilityWithoutUnit,
  },
  computed: {
    ...mapGetters({
      facilitiesWithUnit: 'listingForm/sect2/detail/facilitiesWithUnit',
      facilitiesWithoutUnit: 'listingForm/sect2/detail/facilitiesWithoutUnit',
    }),
  },
  methods: {
    async validate() {
      // console.log('REFS FACILITY WITH UNIT: ', this.$refs.facilityWithUnitRef);
      if (this.$refs.facilityWithUnitRef) {
        const facilityValidation = this.$refs.facilityWithUnitRef.map(function (form) {
          return form.$validate();
        });
        const results = await Promise.all(facilityValidation);
        return (
          results.filter(function (result) {
            return !result;
          }).length === 0
        );
      } else {
        return true;
      }
      // return Promise.all(validationArray).then(function(results) {
      //   return (
      //     results.filter(function(result) {
      //       return !result;
      //     }).length === 0
      //   );
      // });
    },
  },
};
</script>

<style scoped></style>
